import { transformDocumentNumber } from '@/components/custom/erp';
import { isValidUUID } from '@/lib/uuid-validator';
import { FormFieldState } from '../hooks';

export const transformDetailRows = (detailRows: MuaHangRecord[], formMode: string) => {
  return detailRows.map((row: MuaHangRecord, index: number) => ({
    line: index + 1,
    ...(formMode !== 'add' && isValidUUID(row.uuid) ? { uuid: row.uuid } : {}),

    ma_vt: row.ma_vt_data?.uuid || row.ma_vt || null,
    dvt: row.dvt || row.ma_vt_data?.dvt || null,

    ma_kho: row.ma_kho_data?.uuid || row.ma_kho || null,
    ma_vi_tri: row.ma_vi_tri_data?.uuid || row.ma_vi_tri || null,

    so_luong: Number(row.so_luong) || 0,
    gia: Number(row.gia_nt) || 0,
    gia_nt: Number(row.gia_nt) || 0,
    tien: Number(row.tien_nt) || 0,
    tien_nt: Number(row.tien_nt) || 0,

    tk_vt: row.tk_vt_data?.uuid || row.ma_vt_data?.tk_khcp || null,

    ma_thue: row.ma_thue_data?.uuid || row.ma_thue || null,
    thue_suat: parseInt(row.ma_thue_data?.thue_suat) || 0,
    thue_nt: Number(row.thue_nt) || 0,
    thue: Number(row.thue_nt) || 0,

    he_so: 1,

    ma_bp: row.ma_bp_data?.uuid || row.ma_bp || null,
    ma_vv: row.ma_vv_data?.uuid || row.ma_vv || null,
    ma_hd: row.ma_hd_data?.uuid || row.ma_hd || null,
    ma_dtt: row.ma_dtt_data?.uuid || row.ma_dtt || null,
    ma_ku: row.ma_ku_data?.uuid || row.ma_ku || null,
    ma_phi: row.ma_phi_data?.uuid || row.ma_phi || null,
    ma_sp: row.ma_sp_data?.uuid || row.ma_sp || null,
    ma_lsx: row.ma_lsx_data?.uuid || row.ma_lsx || null,
    ma_cp0: row.ma_cp0_data?.uuid || row.ma_cp0 || null,
    id_hd: row.id_hd?.uuid || null,
    line_hd: row.line_hd?.uuid || null
  }));
};

export const transformTaxRows = (
  taxRows: MuaHangRecord[],
  formMode: string,
  state: FormFieldState,
  dien_giai: string
) => {
  return taxRows.map((row: MuaHangRecord, index: number) => ({
    line: index + 1,
    ...(isValidUUID(row.uuid) && formMode !== 'add' ? { uuid: row.uuid } : {}),
    so_ct0: row.so_ct0 || '',
    so_ct2: row.so_ct2 || '',
    ngay_ct0: row.ngay_ct0 || '',
    ma_thue: row.ma_thue_data?.uuid || row.ma_thue || '',
    thue_suat: parseInt(row.ma_thue_data?.thue_suat) || 0,
    ma_mau_ct: row.ma_mau_ct_data?.uuid || '',
    ma_mau_bc: row.ma_mau_bc || '',
    ma_tc_thue: row.ma_tc_thue_data?.uuid || '',
    ma_kh: row.ma_ncc_data?.uuid || state.khachHang?.uuid || '',
    ten_vt_thue: row.ten_vt_thue || dien_giai || '',
    dia_chi: row.ma_ncc_data?.address || '',
    ma_so_thue: row.ma_ncc_data?.tax_code || '',
    t_tien: Number(row.t_tien_nt) || 0,
    t_tien_nt: Number(row.t_tien_nt) || 0,
    tk_thue_no: row.tk_thue_no_data?.uuid || '',
    tk_du: row.tk_du_data?.uuid || '',
    t_thue_nt: Number(row.t_thue_nt) || 0,
    t_thue: Number(row.t_thue_nt) || 0,
    ma_kh9: row.customer_code_data?.uuid || '',
    ma_tt: row.ma_tt_data?.uuid || '',
    ghi_chu: row.ghi_chu || '',
    ma_bp: row.ma_bp_data?.uuid || '',
    ma_vv: row.ma_vv_data?.uuid || '',
    ma_hd: row.ma_hd || '',
    ma_dtt: row.ma_dtt || '',
    ma_ku: row.ma_ku_data?.uuid || '',
    ma_phi: row.ma_phi_data?.uuid || '',
    ma_sp: row.ma_sp_data?.uuid || '',
    ma_lsx: row.ma_lsx_data?.uuid || '',
    ma_cp0: row.ma_cp_data?.uuid || ''
  }));
};

export const transformFormData = (
  data: MuaHangRecord,
  state: FormFieldState,
  detailRows: MuaHangRecord[],
  taxRows: MuaHangRecord[],
  entityUnit: MuaHangRecord,
  formMode: string,
  tongSoLuong: number,
  tongTien: number,
  tongThue: number,
  tongThanhToan: number
) => {
  const detail = transformDetailRows(detailRows, formMode);
  const tax = transformTaxRows(taxRows, formMode, state, data.dien_giai);

  return {
    ...data,
    unit_id: entityUnit?.uuid || null,
    ty_gia: data.ty_gia ? parseFloat(data.ty_gia).toFixed(2) : 1.0,

    ma_kh: state.khachHang?.uuid || null,
    tk: state.taiKhoan?.uuid || state.khachHang?.account_data?.uuid || null,
    ma_tt: state.hanThanhToan?.uuid || state.khachHang?.payment_term_data?.uuid || null,

    ...transformDocumentNumber(state.quyenChungTu, state.soChungTu),

    ngay_lct: data.ngay_ct || new Date().toISOString().split('T')[0],
    ngay_ct0: data.ngay_ct || new Date().toISOString().split('T')[0],
    dien_giai: data.dien_giai || state.khachHang?.description || null,

    t_so_luong: tongSoLuong,
    t_tien_nt: tongTien,
    t_tien: tongTien,
    t_thue_nt: tongThue,
    t_thue: tongThue,
    t_tt_nt: tongThanhToan,
    t_tt: tongThanhToan,

    chi_tiet: detail,
    thue: tax
  };
};
